import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  close: {
    defaultMessage: 'Close',
    id: 'ConsentReadMoreOverlay.close',
  },
  headline: {
    defaultMessage: 'About your data',
    id: 'ConsentReadMoreOverlay.headline',
  },
  aboutYourDataBody: {
    defaultMessage: 'Tink will access your personal data and share it with {appName}.',
    id: 'ConsentReadMoreOverlay.aboutYourDataBody',
  },
  aggregationPartnerBody: {
    defaultMessage:
      'Tink and Tink’s data partners, MX Technologies will access your personal data and share it with {appName}.',
    id: 'ConsentReadMoreOverlay.aggregationPartnerBody',
  },
  headline2: {
    defaultMessage: 'How is your data used?',
    id: 'ConsentReadMoreOverlay.headline2',
  },
  dataCollectionBody1: {
    defaultMessage:
      'Your data will be used by {appName}, Tink, and their data partners to provide you with the services you request, improve those services, comply with legal obligations, protect your identity and security, and generate anonymized information that is not tied to your name, email, or similar identifiers for benchmarking, insights reports, and studies.',
    id: 'ConsentReadMoreOverlay.dataCollectionBody1',
  },
  headline3: {
    defaultMessage: 'Which data will be used?',
    id: 'ConsentReadMoreOverlay.headline3',
  },
  headline4: {
    defaultMessage: 'Who else can access your data?',
    id: 'ConsentReadMoreOverlay.headline4',
  },
  dataCollectionBody2: {
    defaultMessage:
      'Tink partners with MX Technologies. MX Technologies will collect your personal data directly from your financial institution and share it with Tink.',
    id: 'ConsentReadMoreOverlay.dataCollectionBody2',
  },
  headline5: {
    defaultMessage: 'How long do we access your data?',
    id: 'ConsentReadMoreOverlay.headline5',
  },
  subheadline1: {
    defaultMessage: 'Access frequency',
    id: 'ConsentReadMoreOverlay.subheadline1',
  },
  subheadline2: {
    defaultMessage: 'Access validity',
    id: 'ConsentReadMoreOverlay.subheadline2',
  },
  dataSubCollectionBody1Temporary: {
    defaultMessage: 'Your data will be accessed once.',
    id: 'ConsentReadMoreOverlay.dataSubCollectionBody1Temporary',
  },
  dataSubCollectionBody1Permanent: {
    defaultMessage: 'Your data will be accessed up to a maximum of 4 times per day.',
    id: 'ConsentReadMoreOverlay.dataSubCollectionBody1Permanent',
  },
  dataSubCollectionBody2Temporary: {
    defaultMessage: 'Access is valid for 24 hours.',
    id: 'ConsentReadMoreOverlay.dataSubCollectionBody2Temporary',
  },
  dataSubCollectionBody2Permanent: {
    defaultMessage:
      'Access is valid until {appName} or you revoke the consent from Tink. To revoke your consent, you can email Tink at {consentEmailHref}.',
    id: 'ConsentReadMoreOverlay.dataSubCollectionBody2Permanent',
  },
  termsAndConditions: {
    defaultMessage: 'Terms and Conditions',
    id: 'LegalDisclaimer.termsAndConditions',
  },
  privacyPolicy: {
    defaultMessage: 'Privacy Policy',
    id: 'LegalDisclaimer.privacyPolicy',
  },
});
